var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-bottom":"10%"},attrs:{"id":"app"}},[_c('div',{staticClass:"content-main"},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e(),_c('div',{attrs:{"id":"subapp-container"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }